import { useEffect, useState } from 'react';

/**
 * Viewport predicate as state.
 *
 * Tailwind's `lg:` variants handle everything that is purely a matter of
 * arrangement. This exists for the cases where the two layouts render
 * *different content* — the phone Home tab carries the notes card that the
 * desktop puts in its own section — which a class cannot express.
 *
 * `matchMedia` rather than a resize listener: it fires only when the predicate
 * flips, not on every pixel of a drag.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Re-read on mount: the query may have changed between render and effect.
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Matches Tailwind's `lg` breakpoint, which is where the rail appears. */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');
